export default "/_next/static/images/2021-1x-4d025161494ff3520ea0e3f81f34507c.png";